import { render, staticRenderFns } from "./TestReportList.vue?vue&type=template&id=45818ad5&scoped=true&"
import script from "./TestReportList.vue?vue&type=script&lang=js&"
export * from "./TestReportList.vue?vue&type=script&lang=js&"
import style0 from "./TestReportList.vue?vue&type=style&index=0&id=45818ad5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45818ad5",
  null
  
)

export default component.exports